(() => {
	// Tap handler
	function getButtonStyle(item) {
		const { activeStyle, deactiveStyle } = item.dataset;
		const getActive = JSON.parse(JSON.stringify(activeStyle));
		const getDeactive = JSON.parse(JSON.stringify(deactiveStyle));
		const active = getActive.split(" ");
		const deactive = getDeactive.split(" ");

		return { active, deactive };
	}

	const tabButtons = document.querySelectorAll(".tab-button");
	if (tabButtons) {
		tabButtons.forEach((item) => {
			const { active, deactive } = getButtonStyle(item);
			if (item.classList.contains("active")) {
				item.classList.add(...active);
			} else {
				item.classList.add(...deactive);
			}

			item.addEventListener("click", () => {
				const tabName = item.dataset.tabName;
				const targetTabId = item.dataset.targetTab;

				document.querySelectorAll(".tab-button").forEach((item) => {
					if (tabName === item.dataset.tabName) {
						item.classList.remove("active");
						const { activeStyle, deactiveStyle } = item.dataset;
						if (activeStyle && deactiveStyle) {
							const { active, deactive } = getButtonStyle(item);
							item.classList.remove(...active);
							item.classList.add(...deactive);
						}
					}
				});

				item.classList.add("active");
				const { active, deactive } = getButtonStyle(item);
				item.classList.remove(...deactive);
				item.classList.add(...active);

				document.querySelectorAll(".tap-panel").forEach((item) => {
					const panelTabName = item.dataset.tabName;
					if (tabName === panelTabName) {
						if (targetTabId !== item.getAttribute("id")) {
							item.classList.remove("block");
							item.classList.add("hidden");
						} else {
							item.classList.remove("hidden");
							item.classList.add("block");
						}
					}
				});
			});
		});
	}
})();
